import { atom } from 'jotai';

/**
 * Routines whose "Recent runs" rail the user has explicitly dismissed on the
 * run chat page.
 *
 * Keyed by ``workflow_id``, not project id: hopping between runs of the same
 * routine is one continuous surface, so a rail the user closed must stay closed
 * as the route changes. An absent key means "auto" — the rail opens whenever
 * the routine has at least one past run.
 *
 * Session-lived (plain atom, no storage): the default-open behaviour is the
 * designed one, so a refresh deliberately returns to it.
 */
export const recentRunsRailHiddenByUserAtom = atom<Record<string, boolean>>({});
